import React, { useState, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { hasPrivilege } from '../utils/hasPrivilege';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

const AttributeQA = () => {
  const { userData } = useUser();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [academies, setAcademies] = useState([]);
  const location = useLocation();
  const token = localStorage.getItem('auth-token');
  const queryParams = new URLSearchParams(location.search);
  const progressAttributeId = queryParams.get("progressAttributeId");
  const sportId = queryParams.get("sportId");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    if (progressAttributeId) {
      const fetchAcademies = async () => {
        setLoading(true);
        setError(null);

        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_ADMIN_SPORT_PROGRESS_QA}?progressAttributeId=${progressAttributeId}`,
            {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${token}`,
              }
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const text = await response.text();

          if (!text || text.trim() === "null") {
            setAcademies([]);
            return;
          }

          const data = JSON.parse(text);

          if (data.success && data.data?.ProgressAttributeQA) {
            setAcademies(
              data.data.ProgressAttributeQA.map(item => ({
                id: item.id,
                question: item.question,
                answer: item.answer,
              }))
            );
          } else {
            setError(data.success_message || 'Failed to fetch academies');
          }
        } catch (error) {
          setError('Error fetching academies: ' + error.message);
        } finally {
          setLoading(false);
        }
      };

      fetchAcademies();
    } else {
      setError('No progressAttributeId found');
    }
  }, [progressAttributeId]);



  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAcademy, setSelectedAcademy] = useState(null);
  const [action, setAction] = useState('');
  const [formData, setFormData] = useState({ heading: '', subheading: '' });
  const navigate = useNavigate();

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleNewSlider = (event) => {
    const url = `/newAttribute?progressAttributeId=${progressAttributeId}`;
    if (event?.metaKey || event?.ctrlKey) {
      window.open(url, "_blank");
    } else {
      navigate(url);
    }
  };
  const handleEdit = (academyId, event) => {
    const url = `/newAttribute?progressAttributeId=${progressAttributeId}&academyId=${academyId}`;
    if (event?.metaKey || event?.ctrlKey) {
      window.open(url, "_blank");
    } else {
      navigate(url);
    }
  };


  const handleDeleteAcademy = async (academyId, sportId, progressAttributeId) => {

    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_ADMIN_DELETE_PROGRESS_ATTRIBUTE_QA}/${sportId}/${progressAttributeId}/${academyId}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const result = await response.json();

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Academy deleted successfully!',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
      setAcademies(prevAcademies => prevAcademies.filter(academy => academy.id !== academyId));
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to delete academy!',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };



  const filteredAcademies = academies.filter((academy) =>
    Object.values(academy)
      .join(' ')
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredAcademies.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredAcademies.length / rowsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };
  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const totalEntries = filteredAcademies.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;

  return (
    <div className="enrollment-container">
      <div className="breadcrumb">
        <Link to="/sportList" className="breadcrumb-link">Sport List</Link>  &gt; Attribute QA
      </div>
      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            placeholder="🔍 Search"
            className="search-input"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
        <button
          className="create-button-new"
          onClick={(e) => handleNewSlider(e)}
        >

          <span className="create-button__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="23"
              height="23"
              className="create-button__svg"
            >
              <path
                d="M12 5v14M5 12h14"
                stroke="white"
                strokeWidth="2.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="create-button__label">
            Add QA
          </span>
        </button>
      </div>
      <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
        <option value={10}>10 items per page</option>
        <option value={50}>50 items per page</option>
        <option value={75}>75 items per page</option>
        <option value={100}>100 items per page</option>
      </select>
      <div className="pagination-selector">
        <div className="button-group">
          <div className="group-label">Items per page:</div>
          <div className="button-options">
            {[10, 50, 75, 100].map((option) => (
              <button
                key={option}
                onClick={() =>
                  handleItemsPerPageChange({ target: { value: option } })
                }
                className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
              >
                <span className="button-text">{option}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredAcademies.length === 0 && (
        <div className="error-message">No data available</div>
      )}


      <div className="tt-table-container">
        <table className="tt-table">
          <thead>
            <tr>
              <th>Question</th>
              <th>Answer</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentRows.map((academy) => (
              <tr key={academy.id}>
                <td>{academy.question}</td>
                <td>{academy.answer}</td>
                <td className="action-buttons">
                  <button
                    className="edit-btn tooltip-btn"
                    onClick={(e) => handleEdit(academy.id, e)}
                  >

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="white"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M16.862 3.487a2.12 2.12 0 0 1 3.001 3.001L7.5 18.85l-4 1 1-4L16.862 3.487z"
                      />
                    </svg>
                    <span className="tooltip-text">Edit</span>
                  </button>
                  <button className="delete-btn tooltip-btn" onClick={() => handleDeleteAcademy(academy.id, sportId, progressAttributeId)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="white"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 7h12M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M10 11v6M14 11v6M5 7h14l-1 12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 7z"
                      />
                    </svg>
                    <span className="tooltip-text">Delete</span>
                  </button>

                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default AttributeQA
